/* istanbul ignore file */

export { Video as default } from "./Video";
